import { Icon } from "@iconify/react/dist/iconify.js";
import JsFileDownloader from "js-file-downloader";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import {
  clearFormErrors,
  handleAppError,
  setCurrentRecord,
  setLoading,
  showMessage,
} from "../../actions";
import axios from "../../axios";
import { AppSettings, ContractType } from "../../constants";
import AppConfig from "../../constants/AppConfig";
import { DropdownDataFetcher } from "../../libs";
import "../../libs/styles/agreement.scss";
import AgreementEditForm from "./components/AgreementEditForm";
import Filters from "./components/Filter";
import { confirmAlert } from "react-confirm-alert";

function Agreement(props) {
  const [items, setItems] = React.useState([]);
  const [agencies, setAgencies] = useState([]);
  const [universities, setUniversities] = useState([]);
  const [countries, setCountires] = useState([]);
  const [params, setParams] = useState({ filters: { countryid: 2 } });
  const [editableItems, setEditableItems] = useState([]);
  const [savedEdits, setSavedEdits] = useState({}); // saved edits per university
  const [dropdownsData, setDropdownsData] = useState({});
  const firstLoadRef = React.useRef(true);

  const toggleEditableItems = (universityid) => {
    setEditableItems((prev) =>
      prev.includes(universityid)
        ? prev.filter((itemId) => itemId !== universityid)
        : [...prev, universityid]
    );
  };

  // Called when a single university form saves its data (local save only)
  const onSingleFormSave = (universityid) => (data) => {
    setSavedEdits((prev) => ({
      ...prev,
      [universityid]: data,
    }));
    // Optionally close editor after saving:
    setEditableItems((prev) => prev.filter((name) => name !== universityid));
  };

  // Cancel editing for a university
  // const onCancelEdit = (universityid) => {
  //   setEditableItems((prev) => prev.filter((name) => name !== universityid));
  //   // Optionally clear saved edits if you want:
  //   setSavedEdits((prev) => {
  //     const newSaved = { ...prev };
  //     delete newSaved[universityid];
  //     return newSaved;
  //   });
  // };

  // Global submit button handler to send all saved edits

  function allRelatedDataLoaded() {
    if (props.user.is_root_agency) {
      return (
        dropdownsData.facultiesDropdownGet &&
        dropdownsData.commissionDueDatetimeGet &&
        dropdownsData.degreesDropdownGet
      );
    }
  }

  const fetchUniversityDegrees = async () => {
    const data = await DropdownDataFetcher.getDegreesForDropdown(props);

    await setDropdownsData((prev) => ({
      ...prev,
      degreesDropdownGet: data.get,
      degreesDropdownSet: data.set,
    }));

    if (allRelatedDataLoaded()) {
      props.setLoading(false);
    }
  };

  const fetchUniversityFaculties = async () => {
    const data = await DropdownDataFetcher.getUniversitiesFacultiesForDropdown(
      props,
      true
    );

    await setDropdownsData((prev) => ({
      ...prev,
      facultiesDropdownGet: data.get,
      facultiesDropdownSet: data.set,
    }));

    if (allRelatedDataLoaded()) {
      props.setLoading(false);
    }
  };

  const fetchCommissionDueDatetime = async () => {
    const data = await DropdownDataFetcher.getCommissionDueDatetimeForDropdown(
      props
    );

    await setDropdownsData((prev) => ({
      ...prev,
      commissionDueDatetimeGet: data.get,
      commissionDueDatetimeSet: data.set,
    }));
    if (allRelatedDataLoaded()) {
      props.setLoading(false);
    }
  };

  const prepareDataForSubmission = () => {
    const result = [];

    const getCommissionsByLanguage = (
      key,
      language = "nolanguage",
      contracttype = "Standard"
    ) => {
      if (savedEdits[key]?.contracttype === contracttype) {
        return savedEdits[key]?.commissions
          ?.filter((commission) => {
            if (contracttype === ContractType.Standard) {
              return commission?.language === language;
            }
            return commission?.language?.label === language;
          })
          .map((commission) => ({
            ...commission,
            facultyid: commission?.facultyid?.value,
            degree: commission?.degree?.value,
            language:
              contracttype === ContractType.Standard
                ? commission?.language
                : commission?.language?.label,
            commissionduetime: commission?.commissionduetime?.value,
          }));
      }
      return [];
    };

    Object.keys(savedEdits).forEach((key, index) => {
      result[index] = {
        English: getCommissionsByLanguage(
          key,
          "English",
          ContractType.Specific
        ),
        Turkish: getCommissionsByLanguage(
          key,
          "Turkish",
          ContractType.Specific
        ),
        nolanguage: getCommissionsByLanguage(
          key,
          "nolanguage",
          ContractType.Standard
        ),
        bonusagreement: savedEdits[key]?.bonus,
        bonusenabled: savedEdits[key]?.bonusenabled,
        commissionenabled: savedEdits[key]?.commissionenabled,
        scholarshipenabled: savedEdits[key]?.scholarshipenabled,
        contracttype: savedEdits[key]?.contracttype,
        medicalscholarship: parseFloat(
          savedEdits[key]?.medicalscholarship || 0
        ),
        normalscholarship: parseFloat(savedEdits[key]?.normalscholarship || 0),
        scholarshipagreements: savedEdits[key]?.scholarshipagreements,
        supplierid: savedEdits[key].supplierid,
        tax: parseFloat(savedEdits[key]?.tax || 0),
        universitycountryid: savedEdits[key]?.universitycountryid,
        universityid: parseInt(key),
      };
    });

    return result;
  };

  const onSubmitAll = async () => {
    if (Object.keys(savedEdits).length === 0) {
      props.showMessage("No changes to submit.");
      return;
    }

    const records = prepareDataForSubmission();

    console.log({ records });

    try {
      props.setLoading(true);

      const agencyId = params?.filters?.agencyid ?? props.user.agency_id;

      const resp = await axios.put(
        `/agencies/update-agreements/${agencyId}`,
        records
      );

      if (resp?.data?.data?.result) {
        // Re-fetch updated data
        await getAgreementItems();

        props.showMessage({
          type: "success",
          title: window.sys_app_translate(
            "Successful Operation!",
            props.user.lang
          ),
          message: window.sys_app_translate(
            "Agreements updated successfully.",
            props.user.lang
          ),
        });
        setSavedEdits({});
      } else {
        props.showMessage({
          type: "danger",
          title: window.sys_app_translate("Failed Operation!", props.user.lang),
          message: window.sys_app_translate(
            "Update failed or returned unexpected response.",
            props.user.lang
          ),
        });
      }

      props.setLoading(false);
    } catch (error) {
      props.handleAppError(error);
      props.setLoading(false);
    }
  };

  const onDeleteAgreement = async (agencyid, supplierid, universityid) => {
    confirmAlert({
      title: window.sys_app_translate("Confirm Deletion", props.user.lang),
      message: window.sys_app_translate(
        "Are you sure that you want to delete this agreement?",
        props.user.lang
      ),
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              props.setLoading(true);

              const resp = await axios.put(
                `/agencies/delete-agreement/${agencyid}`,
                {
                  supplierid,
                  universityid,
                }
              );

              if (resp?.data?.data?.result) {
                // Re-fetch updated data
                await getAgreementItems();

                props.showMessage({
                  type: "success",
                  title: window.sys_app_translate(
                    "Successful Operation!",
                    props.user.lang
                  ),
                  message: window.sys_app_translate(
                    "Agreement deleted successfully.",
                    props.user.lang
                  ),
                });

                setSavedEdits({});
              } else {
                props.showMessage({
                  type: "danger",
                  title: window.sys_app_translate(
                    "Failed Operation!",
                    props.user.lang
                  ),
                  message: window.sys_app_translate(
                    "Delete failed or returned unexpected response.",
                    props.user.lang
                  ),
                });
              }

              props.setLoading(false);
            } catch (error) {
              props.handleAppError(error);
              props.setLoading(false);
            }
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const getAgreementItems = async () => {
    try {
      props.setLoading(true);
      // const response = await axios.get("/agreement/view", {
      //   params: params,
      // });

      const agencyId = params?.filters?.agencyid ?? props.user.agency_id;

      const response = await axios.get(`/agencies/${agencyId}`);
      console.log(response);

      let items = response.data.data.universitysuppliers;

      // let hasSetShowSeparator = false;
      // items.forEach((item) => {
      //   if (item.countryid !== 2 && !hasSetShowSeparator) {
      //     item.showSeparator = true;
      //     hasSetShowSeparator = true;
      //   }
      // });

      // Filter universities suppliers according to country id
      items = items.filter((item) => {
        // const isAgreementEnabled = item.commissionenabled || item.bonusenabled;

        const universityId = params?.filters?.universityid;
        const countryId = params?.filters?.countryid;

        if (universityId && countryId) {
          return (
            item?.universityid === universityId &&
            item?.universitycountryid === countryId
          );
        }

        if (universityId) {
          return item?.universityid === universityId;
        }

        if (countryId) {
          return item?.universitycountryid === countryId;
        }
      });

      setItems(items);
      props.setLoading(false);
    } catch (error) {
      props.handleAppError(error);
    }
  };

  const _getBonusSection = (bonus, universityid) => {
    if (savedEdits[universityid]) {
      bonus = savedEdits[universityid]["bonus"];
    }

    return (
      <div className="col-12">
        {bonus && Object.keys(bonus)?.length > 0 ? (
          <table
            className="table text-center agreement-table"
            style={{ minWidth: "100%" }}
          >
            <thead>
              <tr>
                <th
                  colSpan={5}
                  className="inter inter-bold"
                  style={{
                    textAlign: "center",
                    color: AppConfig.themeColors.primary,
                    backgroundColor: "#F3F2F2",
                    fontSize: "1.5rem",
                    verticalAlign: "middle",
                  }}
                >
                  <Icon
                    icon={"fa6-solid:money-bill-trend-up"}
                    color={AppConfig.themeColors.primary}
                    fontSize={"1.5rem"}
                    className="mx-2"
                  />
                  {window.sys_app_translate("Bonus", props.user.lang)}
                </th>
              </tr>
              <tr>
                <th
                  className="inter inter-bold"
                  style={{ color: AppConfig.themeColors.primary, width: "20%" }}
                >
                  {window.sys_app_translate("Associate", props.user.lang)}
                </th>
                <th
                  className="inter inter-bold"
                  style={{ color: AppConfig.themeColors.primary, width: "20%" }}
                >
                  {window.sys_app_translate("Bachelor", props.user.lang)}
                </th>
                <th
                  className="inter inter-bold"
                  style={{ color: AppConfig.themeColors.primary, width: "20%" }}
                >
                  {window.sys_app_translate("Master", props.user.lang)}
                </th>
                <th
                  className="inter inter-bold"
                  style={{ color: AppConfig.themeColors.primary, width: "20%" }}
                >
                  {window.sys_app_translate("PHD", props.user.lang)}
                </th>
                <th
                  className="inter inter-bold"
                  style={{ color: AppConfig.themeColors.primary, width: "20%" }}
                >
                  {window.sys_app_translate("Medical", props.user.lang)}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {bonus.associate} {bonus?.associatenature}
                </td>
                <td>
                  {bonus.bachelor} {bonus?.bachelornature}
                </td>
                <td>
                  {bonus.master} {bonus?.masternature}
                </td>
                <td>
                  {bonus.phd} {bonus?.phdnature}
                </td>
                <td>
                  {bonus.medical} {bonus?.medicalnature}
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <></>
        )}
      </div>
    );
  };

  const _getCommissionsSection = (commissions, universityid) => {
    if (savedEdits[universityid]) {
      commissions = savedEdits[universityid]["commissions"];
    }

    return (
      <div className="col-12">
        {commissions && commissions?.length > 0 ? (
          <table
            className="table text-center agreement-table"
            style={{ minWidth: "100%" }}
          >
            <thead>
              <tr>
                <th
                  colSpan={4}
                  className="inter inter-bold"
                  style={{
                    textAlign: "center",
                    color: AppConfig.themeColors.primary,
                    fontSize: "1.5rem",
                    backgroundColor: "#F3F2F2",
                  }}
                >
                  <Icon
                    icon={"fa6-solid:hand-holding-dollar"}
                    color={AppConfig.themeColors.primary}
                    fontSize={"1.5rem"}
                    className="mx-2"
                  />
                  {window.sys_app_translate("Commissions", props.user.lang)}
                </th>
              </tr>
              <tr>
                {commissions?.[0]?.language === "nolanguage" ? null : (
                  <th
                    className="inter inter-bold"
                    style={{ color: AppConfig.themeColors.primary }}
                  >
                    {window.sys_app_translate("Language", props.user.lang)}
                  </th>
                )}
                <th
                  className="inter inter-bold"
                  style={{ color: AppConfig.themeColors.primary }}
                >
                  {window.sys_app_translate("Degree", props.user.lang)}
                </th>
                <th
                  className="inter inter-bold"
                  style={{ color: AppConfig.themeColors.primary }}
                >
                  {window.sys_app_translate("Faculty", props.user.lang)}
                </th>
                <th
                  className="inter inter-bold"
                  style={{ color: AppConfig.themeColors.primary }}
                >
                  {window.sys_app_translate("Commission", props.user.lang)}
                </th>
              </tr>
            </thead>
            <tbody>
              {commissions.map((commission, index) => {
                return (
                  <tr key={index}>
                    {commission?.language === "nolanguage" ? null : (
                      <td
                        className="inter inter-bold"
                        style={{ color: "#686868", width: "25%" }}
                      >
                        {commission?.language?.label}
                      </td>
                    )}
                    <td
                      className={`inter ${
                        commission?.language === "nolanguage"
                          ? "inter-bold"
                          : "inter-medium"
                      }`}
                      style={{
                        color: "#686868",
                        width:
                          commission?.language === "nolanguage" ? "33%" : "25%",
                      }}
                    >
                      {commission?.degree?.label}
                    </td>
                    <td
                      className="inter inter-medium"
                      style={{
                        color: "#686868",
                        width:
                          commission.language === "nolanguage" ? "33%" : "25%",
                      }}
                    >
                      {commission?.facultyid?.label}
                    </td>
                    <td
                      className="inter inter-medium"
                      style={{
                        color: "#686868",
                        width:
                          commission.language === "nolanguage" ? "33%" : "25%",
                      }}
                    >
                      {`${commission?.commission} ${commission?.commissionnature}`}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <></>
        )}
      </div>
    );
  };

  useEffect(() => {
    const fetchAgencies = async () => {
      const agenciesData = await DropdownDataFetcher.getAgenciesForDropdown(
        props,
        true
      );
      setAgencies(agenciesData.get);
    };
    const fetchUniversities = async () => {
      const universitiesData =
        await DropdownDataFetcher.getUniversitiesForDropdown(props);
      setUniversities(universitiesData.get);
    };
    const fetchCountries = async () => {
      const countriesData = await DropdownDataFetcher.getCountriesForDropdown(
        props
      );

      const idsToMatch = [1, 2, 62];

      // Get Turkey & Cyprus & KKTC
      setCountires(
        countriesData.get.filter((item) => idsToMatch.includes(item.value))
      );
    };

    fetchUniversities();
    fetchAgencies();
    fetchCountries();
    fetchUniversityDegrees();
    fetchUniversityFaculties();
    fetchCommissionDueDatetime();
  }, []);

  useEffect(() => {
    // Reset saved edits of agreements
    setSavedEdits({});

    getAgreementItems();

    console.log({ params });
  }, [params]);

  useEffect(() => {
    onSubmitAll();
  }, [savedEdits]);

  // console.log({ items });

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{window.sys_app_translate("Agreement", props.user.lang)}</title>
      </Helmet>
      <Filters
        isRootAgency={props.user.is_root_agency}
        props={props}
        agencies={agencies}
        universities={universities}
        countries={countries}
        doFilter={(filters) => {
          setParams((prevState) => ({
            ...prevState,
            filters: filters,
          }));
        }}
        filters={params?.filters ?? {}}
        exportToPDF={async () => {
          try {
            props.setLoading(true);
            console.log("params ...", params);
            const paramsCopy = { ...params };
            paramsCopy.exporttopdf = true;
            const response = await axios.get("/agreement/view", {
              params: paramsCopy,
            });
            const fileName = response.data.data;
            const fileLink =
              AppConfig.storagePath + "generated-pdfs/" + fileName;
            console.log("fileLink ...", fileLink);
            new JsFileDownloader({
              url: fileLink,
            });
            props.setLoading(false);
          } catch (error) {
            props.handleAppError(error);
          }
        }}
      />
      {/* Global submit button for all saved edits */}
      {/* <div style={{ marginInlineStart: ".75rem" }} className="mb-3">
        <button
          disabled={props.loading}
          onClick={onSubmitAll}
          className="btn btn-primary px-3 py-1 inter"
          style={{
            backgroundColor:
              Object.keys(savedEdits).length === 0
                ? "gray"
                : AppConfig.themeColors.primary,
            borderColor:
              Object.keys(savedEdits).length === 0
                ? "gray"
                : AppConfig.themeColors.primary,
            fontSize: "1.3rem",
          }}
        >
          Submit All Changes
        </button>
      </div> */}

      {items.map((item, index) => {
        const savedData = savedEdits[item.universityid];

        const defaultValues = savedData || {
          tax: item?.tax,
          educationtax: item?.educationtax,
          commissionenabled: item?.commissionenabled,
          bonusenabled: item?.bonusenabled,
          scholarshipenabled: item?.scholarshipenabled,
          contracttype: item?.contracttype,
          medicalscholarship: item?.medicalscholarship,
          normalscholarship: item?.normalscholarship,
          scholarshipagreements: item?.scholarshipagreements,
          universityid: item?.universityid,
          universitycountryid: item?.universitycountryid,
          bonus: item?.bonusagreement,
          commissions: [...item?.nolanguage, ...item.Turkish, ...item.English],
          supplierid: item?.supplierid,
        };

        return (
          <React.Fragment key={index}>
            {item.showSeparator && (
              <div
                row
                className="my-4"
                style={{
                  height: "5px",
                  backgroundColor: AppConfig.themeColors.secondary,
                  borderRadius: "8px",
                }}
              ></div>
            )}
            <div className="row mb-4 position-relative">
              <div className="container-fluid">
                <div
                  className="row py-3"
                  style={{
                    backgroundColor: AppConfig.themeColors.primary,
                    color: "white",
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                  }}
                >
                  <div className="col-8 d-flex justify-content-start align-items-center">
                    <Icon
                      icon={"fa6-solid:file-contract"}
                      color={"white"}
                      fontSize={"1.8rem"}
                      className="mx-2"
                    />
                    <span className="inter" style={{ fontSize: "1.6rem" }}>
                      {window.sys_app_translate("Agreement", props.user.lang)}
                    </span>
                  </div>
                  <div className="col-4 d-flex justify-content-end">
                    <div className="d-flex align-items-center gap-3">
                      {props.user.is_root_agency && (
                        <Icon
                          icon="material-symbols:contract-delete-rounded"
                          fontSize={"2rem"}
                          className="delete-icon"
                          color={"red"}
                          role="button"
                          onClick={() =>
                            onDeleteAgreement(
                              params?.filters?.agencyid ?? props.user.agency_id,
                              item?.supplierid,
                              item?.universityid
                            )
                          }
                        />
                      )}

                      {props.user.is_root_agency &&
                        !editableItems.includes(item.universityid) && (
                          <Icon
                            icon={"material-symbols:contract-edit-rounded"}
                            color={"white"}
                            fontSize={"2rem"}
                            className="mx-2 edit-icon"
                            role="button"
                            onClick={() => {
                              let agencyId = props.user.agency_id;
                              if (params.filters && params.filters.agencyid) {
                                agencyId = params.filters.agencyid;
                              }
                              if (agencyId === AppSettings.SystemAgencyID) {
                                props.setCurrentRecord(agencyId);
                              } else {
                                props.setCurrentRecord({
                                  agencyid: agencyId,
                                  step: 3,
                                });
                              }

                              toggleEditableItems(item.universityid);
                            }}
                          />
                        )}
                    </div>
                  </div>
                </div>
                <div className="row py-4" style={{ backgroundColor: "white" }}>
                  <div className="col-2">
                    <img
                      style={{ width: "100%" }}
                      src={
                        "https://itqanapply.com/storage/" + item.universitylogo
                      }
                      alt="University Logo"
                    />
                  </div>
                  <div className="col-10">
                    <h1
                      className="inter inter-bold"
                      style={{ color: "#686868", fontSize: "2rem" }}
                    >
                      {item.universityname}
                      <span
                        className="inte inter-medium mx-2"
                        style={{
                          fontSize: "2rem",
                          color: AppConfig.themeColors.secondary,
                        }}
                      >
                        {defaultValues?.commissions?.[0]?.commissionduetime
                          ?.label === "Cash"
                          ? `(${window.sys_app_translate(
                              defaultValues?.commissions?.[0]?.commissionduetime
                                ?.label,
                              props.user.lang
                            )})`
                          : null}
                      </span>
                    </h1>
                    <h2
                      className="inter inter-bold"
                      style={{
                        color: AppConfig.themeColors.primary,
                        fontSize: "1.5rem",
                      }}
                    >
                      {window.sys_app_translate(
                        "Agreement Information",
                        props.user.lang
                      )}
                    </h2>
                    <p
                      className="inter inter-medium"
                      style={{ color: "#686868", fontSize: "1.5rem" }}
                    >
                      {parseInt(defaultValues?.educationtax) !== 0 && (
                        <>
                          {`${window.sys_app_translate("Education Tax")}: ${
                            defaultValues?.educationtax
                          }%`}
                          <br />
                        </>
                      )}

                      {(savedEdits[item.universityid]?.tax &&
                        parseInt(savedEdits[item.universityid]?.tax) !== 0) ||
                      (item.tax && parseInt(item.tax) !== 0) ? (
                        <>
                          {`${window.sys_app_translate("KDV")}:  ${
                            defaultValues?.tax
                          }%`}
                          <br />
                        </>
                      ) : null}

                      {/* {item.tax && parseInt(item.tax) !== 0 && (
                        <>
                          {`${window.sys_app_translate("KDV")}:  ${
                            defaultValues?.tax
                          }%`}
                          <br />
                        </>
                      )} */}

                      {/* {defaultValues?.commissions &&
                        defaultValues?.commissions?.length > 0 && (
                          <>
                            {window.sys_app_translate("Bonus", props.user.lang)}
                            {": "}
                            {window.sys_app_translate(
                              defaultValues?.commissions?.[0]?.commissionduetime
                                ?.label,
                              props.user.lang
                            )}
                            <br />
                          </>
                        )} */}

                      {/* {defaultValues?.commissions?.[0]?.commissionnature
                        ? `${window.sys_app_translate(
                            "Your Commission",
                            props.user.lang
                          )}: ${defaultValues?.commissions?.[0]?.commission} ${
                            defaultValues?.commissions?.[0]?.commissionnature
                          }`
                        : null} */}

                      {item?.universitycountryname &&
                        `${window.sys_app_translate(
                          "Country",
                          props.user.lang
                        )}: ${item?.universitycountryname}`}

                      <br />

                      {params.filters &&
                        params.filters.agencyid &&
                        params.filters.agencyid ===
                          AppSettings.SystemAgencyID &&
                        `${window.sys_app_translate("Supplier")}: ${
                          item.suppliername
                        }`}
                    </p>
                  </div>
                </div>
                <div
                  className="row"
                  style={{
                    backgroundColor: "white",
                    borderBottomLeftRadius: "5px",
                    borderBottomRightRadius: "5px",
                  }}
                >
                  {/* Commissions */}
                  {defaultValues?.commissions &&
                    defaultValues?.commissions?.length > 0 &&
                    !editableItems.includes(item.universityid) &&
                    _getCommissionsSection(
                      defaultValues.commissions,
                      item.universityid
                    )}

                  {/* Bonus */}
                  {defaultValues?.bonus &&
                    Object.keys(defaultValues.bonus).length > 0 &&
                    !editableItems.includes(item.universityid) &&
                    _getBonusSection(defaultValues.bonus, item.universityid)}
                </div>
                <div
                  className="row"
                  style={{
                    backgroundColor: "white",
                    borderBottomLeftRadius: "5px",
                    borderBottomRightRadius: "5px",
                  }}
                >
                  {(defaultValues?.commissions || defaultValues?.bonus) &&
                    // item.commissions.length > 0 &&
                    editableItems.includes(item.universityid) && (
                      <AgreementEditForm
                        defaultValues={defaultValues}
                        dropdownsData={dropdownsData}
                        onSave={onSingleFormSave(item.universityid)}
                        props={props}
                      />
                    )}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </>
  );
}

// map state to props
const mapStateToProps = ({ authUser, appReducer }) => {
  const { user } = authUser;
  const { formErrors, currentRecord } = appReducer;
  return { user, formErrors, currentRecord };
};
export default connect(mapStateToProps, {
  setLoading,
  showMessage,
  handleAppError,
  clearFormErrors,
  setCurrentRecord,
})(Agreement);
